/**
 * Logo - Reusable logo/company name component
 *
 * Displays the General Wisdom logo SVG with consistent sizing.
 * Uses theme-specific SVG files: dark mode uses white letters, light mode uses black letters.
 */
import { useMemo } from 'react';

import { useTheme } from '@/theme';

export function Logo() {
  const { theme } = useTheme();

  const resolvedTheme = useMemo(() => {
    if (theme !== 'system') return theme;

    if (typeof window === 'undefined') return 'light';
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }, [theme]);

  const logoSrc =
    resolvedTheme === 'dark' ? '/gw-primary-logo-dark.svg' : '/gw-primary-logo-light.svg';

  return <img src={logoSrc} alt="General Wisdom" className="h-28 w-auto" />;
}
